import { render, staticRenderFns } from "./subCategorySlider.vue?vue&type=template&id=5129af23"
import script from "./subCategorySlider.vue?vue&type=script&lang=js"
export * from "./subCategorySlider.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports